export enum LocationDialogModeEnum {
  Create = 'create',
  Edit = 'edit',
  View = 'view',
}

export const LocationDialogModeEnumLabels: Record<LocationDialogModeEnum, string> = {
  [LocationDialogModeEnum.Create]: 'Añadir',
  [LocationDialogModeEnum.Edit]: 'Editar',
  [LocationDialogModeEnum.View]: 'Ver',
};

export function getLocationDialogModeLabel(mode: LocationDialogModeEnum): string {
  return LocationDialogModeEnumLabels[mode];
}
